import { Search, X } from "lucide-react";
import { WORK } from "@/constants/testIds";
import { PortfolioSort } from "@/components/PortfolioSort";

const selectClass =
  "max-w-full min-w-0 bg-[#181818] border border-[#2A2A2A] focus:border-[#CCFF00] outline-none text-xs uppercase tracking-wider text-[#F5F5F0] px-2 min-h-[40px] transition-colors";

const pillClass = (active) =>
  `shrink-0 text-xs uppercase tracking-widest px-3 min-h-[40px] flex items-center border transition-colors ${
    active ? "border-[#CCFF00] text-[#CCFF00]" : "border-[#2A2A2A] text-[#888880] hover:text-[#F5F5F0] hover:border-[#555550]"
  }`;

export const WorkFilterBar = ({
  facets,
  search,
  category,
  account,
  aiOnly,
  yearFrom,
  yearTo,
  sort,
  onSearch,
  onCategory,
  onAccount,
  onAiOnly,
  onYearFrom,
  onYearTo,
  onSort,
  onClear,
  resultCount,
  totalCount,
}) => {
  const years = facets?.yearMin && facets?.yearMax
    ? Array.from({ length: facets.yearMax - facets.yearMin + 1 }, (_, i) => facets.yearMax - i)
    : [];
  const hasActive = category !== "all" || account !== "all" || aiOnly || yearFrom !== "all" || yearTo !== "all" || search.trim() !== "";

  return (
    <div className="w-full border-b border-[#2A2A2A] bg-[#101010]">
      <div className="max-w-[1600px] mx-auto px-3 sm:px-6 py-3 flex flex-wrap items-center gap-2 sm:gap-3">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#555550]" />
          <input
            type="text"
            value={search}
            onChange={(e) => onSearch(e.target.value)}
            placeholder="Search brand, keyword, caption…"
            aria-label="Search the portfolio"
            data-testid={WORK.searchInput}
            className="w-full bg-[#181818] border border-[#2A2A2A] focus:border-[#CCFF00] outline-none text-sm text-[#F5F5F0] placeholder:text-[#555550] pl-8 pr-3 min-h-[44px] transition-colors"
          />
        </div>

        <select aria-label="Filter by category" data-testid={WORK.categorySelect} value={category} onChange={(e) => onCategory(e.target.value)} className={selectClass}>
          <option value="all">All Categories</option>
          {(facets?.categories || []).map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>

        <select aria-label="Filter by Instagram account" data-testid={WORK.accountSelect} value={account} onChange={(e) => onAccount(e.target.value)} className={selectClass}>
          <option value="all">All Accounts</option>
          {(facets?.accounts || []).map((a) => (
            <option key={a} value={a}>
              @{a}
            </option>
          ))}
        </select>

        <select aria-label="Filter from year" data-testid={WORK.yearFromSelect} value={yearFrom} onChange={(e) => onYearFrom(e.target.value)} className={selectClass}>
          <option value="all">From Year</option>
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
        <select aria-label="Filter to year" data-testid={WORK.yearToSelect} value={yearTo} onChange={(e) => onYearTo(e.target.value)} className={selectClass}>
          <option value="all">To Year</option>
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>

        <button type="button" aria-label="Show AI films only" aria-pressed={aiOnly} data-testid={WORK.aiToggle} onClick={() => onAiOnly(!aiOnly)} className={pillClass(aiOnly)}>
          AI Film Only
        </button>

        <PortfolioSort value={sort} onChange={onSort} />

        {hasActive && (
          <button
            type="button"
            data-testid={WORK.clearAll}
            onClick={onClear}
            className="shrink-0 flex items-center gap-1 text-xs uppercase tracking-widest px-3 min-h-[40px] text-[#888880] hover:text-[#CCFF00] transition-colors"
          >
            <X size={12} /> Clear
          </button>
        )}

        <span data-testid={WORK.resultCount} className="text-xs text-[#555550] ml-auto whitespace-nowrap">
          {resultCount} of {totalCount} films
        </span>
      </div>
    </div>
  );
};

export default WorkFilterBar;
